import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { GsaFilters } from './GsaMasCatalog.types'
import './GsaMasCatalog.css'

type Props = {
  filters: GsaFilters
  setFilter: <K extends keyof GsaFilters>(key: K, value: GsaFilters[K]) => void
  clearFilters: () => void
  advancedOpen: boolean
  setAdvancedOpen: (open: boolean) => void
  onSearch: () => void
}

export default function GsaMasCatalogFilters({
  filters,
  setFilter,
  clearFilters,
  advancedOpen,
  setAdvancedOpen,
  onSearch,
}: Props) {
  return (
    <Paper elevation={0} className="gsa-filter-container">
      <div className="gsa-filter-input-row">
        <TextField
          label="Award / Mod No."
          size="small"
          className="gsa-filter-input"
          value={filters.awardModNo}
          onChange={e => setFilter('awardModNo', e.target.value)}
          onKeyDown={e => e.key === 'Enter' && onSearch()}
        />
        <TextField
          label="Vendor Name"
          size="small"
          className="gsa-filter-input"
          value={filters.vendorName}
          onChange={e => setFilter('vendorName', e.target.value)}
          onKeyDown={e => e.key === 'Enter' && onSearch()}
        />
        <TextField
          label="Manufacturer Name"
          size="small"
          className="gsa-filter-input"
          value={filters.manufacturerName}
          onChange={e => setFilter('manufacturerName', e.target.value)}
          onKeyDown={e => e.key === 'Enter' && onSearch()}
        />
        <Button size="large" variant="contained" onClick={onSearch}>
          Search
        </Button>
        <Button size="large" variant="outlined" onClick={clearFilters}>
          Clear
        </Button>
      </div>

      <Accordion
        className="gsa-filter-advanced-search"
        expanded={advancedOpen}
        onChange={(_e, expanded) => setAdvancedOpen(expanded)}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography>Advanced Search</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing="17px">
            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">Mfr Part No.:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                size="small"
                label="Mfr Part No."
                fullWidth
                value={filters.mfrPartNo}
                onChange={e => setFilter('mfrPartNo', e.target.value)}
                onKeyDown={e => e.key === 'Enter' && onSearch()}
              />
            </Grid>
            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">Product Description:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                size="small"
                label="Product Description"
                fullWidth
                value={filters.productDescription}
                onChange={e => setFilter('productDescription', e.target.value)}
                onKeyDown={e => e.key === 'Enter' && onSearch()}
              />
            </Grid>
            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">Contract / Offer No.:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                size="small"
                label="Contract / Offer No."
                fullWidth
                value={filters.contractOfferNo}
                onChange={e => setFilter('contractOfferNo', e.target.value)}
                onKeyDown={e => e.key === 'Enter' && onSearch()}
              />
            </Grid>

            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">Vendor Part No.:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                size="small"
                label="Vendor Part No."
                fullWidth
                value={filters.vendorPartNo}
                onChange={e => setFilter('vendorPartNo', e.target.value)}
                onKeyDown={e => e.key === 'Enter' && onSearch()}
              />
            </Grid>
            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">UEI:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                size="small"
                label="UEI"
                fullWidth
                value={filters.uei}
                onChange={e => setFilter('uei', e.target.value)}
                onKeyDown={e => e.key === 'Enter' && onSearch()}
              />
            </Grid>
            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">Base or Accessory:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                select
                size="small"
                label="Base or Accessory"
                fullWidth
                value={filters.baseOrAccessory}
                onChange={e => setFilter('baseOrAccessory', e.target.value)}
              >
                <MenuItem value="">All</MenuItem>
                <MenuItem value="B - BASE">B - BASE</MenuItem>
                <MenuItem value="A - ACCESSORY">A - ACCESSORY</MenuItem>
              </TextField>
            </Grid>

            <Grid size={1.5} className="gsa-filter-advanced-search-grid">
              <Typography variant="body2">Product Name:</Typography>
            </Grid>
            <Grid size={2.5} className="gsa-filter-advanced-search-grid">
              <TextField
                size="small"
                label="Product Name"
                fullWidth
                value={filters.productName}
                onChange={e => setFilter('productName', e.target.value)}
                onKeyDown={e => e.key === 'Enter' && onSearch()}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    </Paper>
  )
}
